import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  ViewChild
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { finalize, tap } from 'rxjs/operators';

import { MarkFormAsTouchedIfInvalid } from 'tiime-expert-utils';
import { DialogBase, SnackbarConfig, TiimeSnackbarService } from 'tiime-material';

import { DocumentApiService } from '@api-services/document-api.service';
import { DocumentCategory } from '@models/document-category';

import { CreateDocumentCategoryDialogData } from './create-document-category-dialog-data';

@Component({
  selector: 'app-create-document-category-dialog',
  templateUrl: './create-document-category-dialog.component.html',
  styleUrls: ['./create-document-category-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateDocumentCategoryDialogComponent
  extends DialogBase<CreateDocumentCategoryDialogComponent>
  implements AfterViewInit
{
  @ViewChild('nameInput') nameInput: ElementRef;

  nameControl = new FormControl<string | null>(null, Validators.required);

  get nameErrorMessage(): string | null {
    return this.nameControl.touched && this.nameControl.hasError('required') ? 'Nom requis' : null;
  }

  constructor(
    dialogRef: MatDialogRef<CreateDocumentCategoryDialogComponent>,
    private documentApiService: DocumentApiService,
    private snackbarService: TiimeSnackbarService,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) private data: CreateDocumentCategoryDialogData
  ) {
    super(dialogRef);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.nameControl?.setValue(this.data.name);
      this.nameInput?.nativeElement.focus();
    });
  }

  @MarkFormAsTouchedIfInvalid('nameControl')
  createDocumentCategory(): void {
    this.nameControl.disable();
    this.isLoading.set(true);

    this.documentApiService
      .createDocumentCategory(this.nameControl.value)
      .pipe(
        tap((documentCategory: DocumentCategory) => this.close(documentCategory)),
        tap(() => this.snackbarService.open(`L'espace a bien été crée`, SnackbarConfig.success)),
        finalize(() => {
          this.nameControl.enable();
          this.isLoading.set(false);
          this.cdr.markForCheck();
        })
      )
      .subscribe();
  }
}
